import { requirePermission } from "@lib/permissions/guards";
import { createFileRoute } from "@tanstack/react-router";
import ProfilRemiseView from "@/features/ventes/components/tarifs/ProfilRemiseView";
import { TARIF_PERMISSIONS } from "@/features/ventes/config/tarifs/constants";

export const Route = createFileRoute("/_app/ventes/tarifs/remises/$id/view")({
  loader: requirePermission(TARIF_PERMISSIONS.PROFILS_VIEW),
  staticData: {
    title: "Détails profil de remise",
    showInBreadcrumb: true,
  },
  component: ProfilRemiseView,
});
